import useAsyncData from "../../../hooks/use-async-data";
import rideService from "../ride.service";
import RideSolved from "./ride-solved";
import RideSolvedParams from "./ride-solved-params";

const useRideSolved = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<RideSolved>({ seq: [] });

  const load = async (
    params: RideSolvedParams,
    signal: AbortSignal,
  ): Promise<void> => {
    setIsLoading(true);
    setIsError(false);

    try {
      const rideSolved = await rideService.fetchSolvedRides(params, signal);

      setData(rideSolved);
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const reset = () => {
    setData({ seq: [] });
  };

  return {
    isLoading,
    isError,
    data,
    load,
    reset,
  };
};

export default useRideSolved;
